/**
 * Ruta `/instalar` (US2, T033): paso iOS previo al registro (research R-5).
 *
 * Instrucciones "Compartir → Agregar a inicio" y código de traspaso para continuar dentro de la PWA
 * instalada. El token de la invitación viene de `sessionStorage`; sin él (o si la invitación dejó de
 * ser válida) se muestra la pantalla de enlace inválido.
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback, useState } from 'react';

import { getActivationToken } from '../features/activation/activation-store';
import { InstallIosScreen } from '../features/activation/install-ios';
import { InvalidLinkScreen } from '../features/activation/link-invalid';
import { t } from '../i18n';

export function InstallRoute() {
  const navigate = useNavigate();
  const [token] = useState(() => getActivationToken());
  const [gone, setGone] = useState(false);
  const onGone = useCallback(() => setGone(true), []);
  // 005 · QA-6: sin el documento verificado no hay código de traspaso; de vuelta al enlace.
  const onVerificationRequired = useCallback(() => {
    if (token !== null) {
      void navigate({ to: '/activar/$token', params: { token }, replace: true });
    }
  }, [navigate, token]);

  if (token === null) {
    return <InvalidLinkScreen description={t('activation.invalid.noToken')} />;
  }
  if (gone) {
    return <InvalidLinkScreen />;
  }

  return (
    <InstallIosScreen
      token={token}
      onContinueInBrowser={() => void navigate({ to: '/registrar' })}
      onGone={onGone}
      onVerificationRequired={onVerificationRequired}
    />
  );
}

export const Route = createFileRoute('/instalar')({
  component: InstallRoute,
});
